import { createFileRoute } from "@tanstack/react-router";
import { SectionPage } from "@/components/site/SectionPage";

export const Route = createFileRoute("/riders")({
  head: () => ({
    meta: [
      { title: "Riders — Cowhide Motorcycle Gear — KAKAIYS" },
      { name: "description", content: "Heavyweight cowhide riding jackets, vests and gloves with CE-rated armour pockets and reinforced panels. Built for the road." },
      { property: "og:title", content: "Riders — KAKAIYS" },
      { property: "og:description", content: "Cowhide motorcycle jackets, vests and gloves." },
      { name: "twitter:image", content: "https://tvmsfjwzfnidomctinqz.supabase.co/storage/v1/object/public/product-images/seed/rider-vagabond-jacket.jpg" },
      { property: "og:url", content: "https://kakaiys.com/riders" },
    ],
      links: [{ rel: "canonical", href: "https://kakaiys.com/riders" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Riders — KAKAIYS",
          description: "Café racers, aviators and moto-inspired leather jackets.",
          url: "https://kakaiys.com/riders",
          isPartOf: { "@id": "https://kakaiys.com/#website" },
          publisher: { "@id": "https://kakaiys.com/#organization" },
        }),
      },
    ],
  }),
  component: () => (
    <SectionPage
      eyebrow="Riders"
      title="Built for the Road."
      subtitle="Heavyweight cowhide. Reinforced panels. CE-rated armour pockets. The leather that survives the road."
      filterTag="riders"
    />
  ),
});
